import React from "react";
import { Outlet } from "react-router-dom";
import { LinkTabs } from "../framework/linkTabs";
import { useTranslation } from "react-i18next";

export const SettingTabs = () => {
    const { t } = useTranslation();
    const tabs = [
        {
            value: "vehicles",
            label: t("settings.vehicles.vehicleSelection"),
            matchPaths: ["/settings/vehicles/*"],
            to: "/settings/vehicles",
            children: <Outlet />,
        },
        {
            value: "costCenters",
            label: t("settings.costCenters.myCostCenters"),
            matchPaths: ["/settings/costcenters/*"],
            to: "/settings/costcenters",
            children: <Outlet />,
        },
        {
            value: "profile",
            label: t("profile.passwordChange.changePassword"),
            matchPaths: ["/settings/profile/*"],
            to: "/settings/profile",
            children: <Outlet />,
        },
        {
            value: "language",
            label: t("settings.language.language"),
            matchPaths: ["/settings/language/*"],
            to: "/settings/language",
            children: <Outlet />,
        }
    ];

    return <LinkTabs tabs={tabs} />;
};
